import React, { useContext, useState, useRef, useEffect } from 'react'
import Modals from '../../shared/Modals'
import { DataTable } from 'primereact/datatable'
import { Column } from 'primereact/column'
import { formatCurrency } from '../../shared/utils'
import server from '../../../server'
import { ToastPopUp } from '../../shared/utils'
import { Toast } from 'primereact/toast'
import { AuthenticationContext } from '../../../Auth/authentication.context'
import useTableRowsPerPage from '../../../hooks/useTableRowsPerPage'
import { getInitialPaginationState } from '../../../shared/tablePagination'
import { Message } from 'primereact/message'
import originsDirect from '../../../assets/images/ORIGINS-DIRECT.png'
import originsDirectInstant from '../../../assets/images/ORIGINS-DIRECT-INSTANT.png'
import originsManagement from '../../../assets/images/ORIGINS-MANAGEMENT.png'
import ConfirmOrderModal from './ConfirmOrderModal'
import { clearDraftOrder } from '../draftOrderApi'

// A manufacturer's order can be placed once its total reaches the minimum.
// Mirrors the backend check (rejects only when gpMinOrderPrice > total).
const meetsMinimum = ({ TotalAmount, gpMinOrderPrice }) =>
  (gpMinOrderPrice || 0) <= TotalAmount

const OrderSummary = ({
  visible,
  setVisible,
  orderData,
  total,
  subtotal,
  handleSuccess,
  ordableProducts,
  paPercentage,
  paData,
  onClose,
}) => {
  const { status, setStatus, setBannerMsg, module, user: contextUser } =
    useContext(AuthenticationContext)
  const { defaultRows, rowsPerPageOptions, applyPageEvent } = useTableRowsPerPage()
  const userFromStorage = localStorage.getItem('user')
  const userData = userFromStorage ? JSON.parse(userFromStorage) : contextUser
  const userForGroup = contextUser || userData
  const isGroupMember = !!(userForGroup?.pharmacy?.pharmacyGroup || userForGroup?.pharmacyGroup)
  const isOriginsDirectGroupMember =
    isGroupMember &&
    (module === 'Origins Direct' || module === 'Origins Direct Instant')
  console.log(userData)
  const pharmacyId = userData?.pharmacyModules[0]?.pharmacyId || null
  console.log('pharmacyId', pharmacyId)
  const [data, setData] = useState([])
  const [tableLoading, setTableLoading] = useState(false)
  const [check, setCheck] = useState(true)
  const [loading, setLoading] = useState(false)
  const [paymentDetails, setPaymentDetails] = useState(null)
  const [pyNumber, setPyNumber] = useState(null)
  const [totalAmount, setTotalAmount] = useState(0)
  console.log('paData', paData?.paAmount)
  const [state, setState] = useState(() =>
    getInitialPaginationState(contextUser)
  )
  const toast = useRef(null)

  useEffect(() => {
    setState((prev) => ({ ...prev, rows: defaultRows }))
  }, [defaultRows])
  const [orderTypeSelections, setOrderTypeSelections] = useState({})
  const [showConfirmContent, setShowConfirmContent] = useState(false)
  const [termsAccepted, setTermsAccepted] = useState(false)

  // Set your shipping fee here (replace with dynamic value if needed)
  const shippingFee = 500 // or get from props/data

  useEffect(() => {
    setData(orderData)
  }, [orderData])

  // Calculate if any manufacturer doesn't meet minimum order requirements
  // This should be calculated after manufacturerTotals is computed

  // Calculate manufacturerTotals and include shippingFee
  const manufacturerTotals = data.reduce((totals, item) => {
    const manufacturer = item?.manufacturer?.name
    const subtotal = parseFloat(item.subtotal)
    const gpMinOrderPrice = item?.manufacturer?.gpMinOrderPrice || 0
    const shippingFee = item?.manufacturer?.shippingFee || 0

    if (!totals[manufacturer]) {
      totals[manufacturer] = {
        TotalAmount: 0,
        gpMinOrderPrice: 0,
        shippingFee: 0,
      }
    }

    const leadTime = item?.manufacturer.leadTime
    const cutOffTime = item?.manufacturer.cutOffTime
    let currentTime = new Date().toLocaleTimeString([], {
      hour12: false,
      hour: '2-digit',
      minute: '2-digit',
    })

    const calculateDelivery = () => {
      let deliveryTime

      if (cutOffTime > currentTime) {
        deliveryTime = leadTime
      } else {
        deliveryTime = leadTime + 1
      }

      if (deliveryTime === 0) {
        return 'Today'
      } else {
        return `${deliveryTime} Working days`
      }
    }

    totals[manufacturer].TotalAmount += subtotal
    totals[manufacturer].gpMinOrderPrice = gpMinOrderPrice
    totals[manufacturer].deliveryTime = calculateDelivery()
    totals[manufacturer].confirmed = item?.confirmed
    totals[manufacturer].shippingFee = shippingFee // add shipping fee

    return totals
  }, {})

  // Split the cart: manufacturers that meet their minimum are ordered now, the
  // rest stay in the draft so the pharmacy can top them up later.
  const itemMeetsMinimum = (item) => {
    const totals = manufacturerTotals[item?.manufacturer?.name]
    return totals ? meetsMinimum(totals) : true
  }
  const itemsToOrder = data.filter(itemMeetsMinimum)
  const itemsToKeepInDraft = data.filter((item) => !itemMeetsMinimum(item))

  const manufacturersData = Object.keys(manufacturerTotals).map(
    (manufacturer) => {
      const item = data.find(
        (item) => item?.manufacturer?.name === manufacturer
      )
      let systems = []
      if (Array.isArray(item?.manufacturer?.system)) {
        systems = item.manufacturer.system
      } else if (item?.manufacturer?.system) {
        systems = [item.manufacturer.system]
      }
      return {
        Manufacturer: manufacturer,
        TotalAmount: manufacturerTotals[manufacturer].TotalAmount,
        gpMinOrderPrice: manufacturerTotals[manufacturer].gpMinOrderPrice,
        deliveryTime: manufacturerTotals[manufacturer].deliveryTime,
        confirmed: meetsMinimum(manufacturerTotals[manufacturer]),
        systems, // always an array
        shippingFee: manufacturerTotals[manufacturer].shippingFee, // add shipping fee
      }
    }
  )

  // Calculate total shipping fee for all manufacturers
  const totalShippingFee = manufacturersData.reduce(
    (sum, m) => sum + (m.shippingFee || 0),
    0
  )
  console.log('totalShippingFee', totalShippingFee)

  console.log('manufacturersData ✔️✔️', manufacturersData[0]?.system)

  useEffect(() => {
    if (!visible || !pharmacyId) {
      return undefined
    }

    let cancelled = false
    const loadPaymentProfile = async () => {
      setTableLoading(true)
      try {
        const response = await server.get(
          `/payments/pharmacy-payment-profile/${pharmacyId}`
        )
        if (cancelled) return

        const cardNumber =
          response?.data?.paymentProfile?.payment?.creditCard?.cardNumber
        if (cardNumber) {
          setPaymentDetails(cardNumber)
          setPyNumber(String(cardNumber).replace('XXXX', '****'))
        } else {
          setPaymentDetails(null)
          setPyNumber(null)
        }
      } catch (error) {
        if (!cancelled) {
          console.warn(
            'Payment profile unavailable:',
            error?.response?.data?.message || error?.message || error
          )
          setPaymentDetails(null)
          setPyNumber(null)
        }
      } finally {
        if (!cancelled) {
          setTableLoading(false)
        }
      }
    }

    loadPaymentProfile()
    return () => {
      cancelled = true
    }
  }, [visible, pharmacyId])

  useEffect(() => {
    const anyConfirmed = manufacturersData.some(
      (item) => item.confirmed === true
    )
    setCheck(anyConfirmed)
  }, [manufacturersData])

  // Calculate totalAmount as sum of total and totalShippingFee
  useEffect(() => {
    // Convert total to number if it's a formatted string
    let numericTotal = total
    if (typeof total === 'string') {
      // Remove currency symbols, commas, and spaces, then convert to number
      numericTotal = parseFloat(total.replace(/[^0-9.-]+/g, ''))
    }

    const calculatedTotal = numericTotal + totalShippingFee
    setTotalAmount(calculatedTotal)
  }, [total, totalShippingFee])
  console.log('totalAmount', totalAmount)
  const modalBtnName = check ? 'CONFIRM ORDER' : 'EDIT ORDER'
  const handleOrder = () => {
    // Check if at least one Origins Direct or Origins Direct Instant is selected
    const hasDirectOrderSelected = Object.values(orderTypeSelections).some(
      (system) =>
        system === 'Origins Direct' || system === 'Origins Direct Instant'
    )

    if (check && hasDirectOrderSelected) {
      setShowConfirmContent(true)
    } else {
      setVisible(false)
    }
  }

  const handleClose = () => {
    setShowConfirmContent(false)
    setVisible(false)
  }

  const handleOrderConfirm = () => {
    if (!termsAccepted) {
      ToastPopUp(
        toast,
        'error',
        'Error',
        'Please accept all terms and conditions to proceed'
      )
      return
    }

    // Check if at least one Origins Direct or Origins Direct Instant is selected
    const hasDirectOrderSelected = Object.values(orderTypeSelections).some(
      (system) =>
        system === 'Origins Direct' || system === 'Origins Direct Instant'
    )

    if (!hasDirectOrderSelected) {
      ToastPopUp(
        toast,
        'error',
        'Error',
        'Please select at least one Origins Direct or Origins Direct Instant order type to proceed'
      )
      return
    }

    if (itemsToOrder.length === 0) {
      ToastPopUp(
        toast,
        'error',
        'Minimum Order Not Met',
        'No manufacturer in your order meets its minimum order amount yet.'
      )
      return
    }

    // Only submit manufacturers that meet their minimum; the rest stay in draft
    const filteredData = itemsToOrder
    const keptInDraft = itemsToKeepInDraft
    const orderDetails = filteredData.map((item) => {
      // Find the manufacturer for this product
      const manufacturer = item?.manufacturer?.name
      // Default to "Origins Direct" (systems selection UI is commented out)
      const selectedSystem = orderTypeSelections[manufacturer] || 'Origins Direct'

      return {
        productId: item.id,
        quantity: item.quantity,
        system: selectedSystem,
      }
    })

    // Default to "Origins Direct" for payload (e.g. pyNumber conditional)
    const selectedSystem = Object.values(orderTypeSelections)[0] || 'Origins Direct'

    const payload = {
      details: orderDetails,
      estimatedPaAmount: paData?.paAmount,
    }

    if (selectedSystem !== 'Origins Direct') {
      payload.pyNumber = pyNumber
    }

    setLoading(true)
    server
      .post(`/invoicesHeaders/pharmacy`, payload)
      .then((response) => {
        setLoading(false)
        setVisible(false)
        ordableProducts(orderDetails)
        setStatus(response?.data?.userBanner?.status)
        setBannerMsg(response?.data?.userBanner?.message)
        // Hand back the items that weren't ordered so they stay in the draft
        handleSuccess(keptInDraft)
        if (keptInDraft.length === 0) {
          // Clear the order data from localStorage
          localStorage.removeItem('myOrder')
          // Empty the persisted draft on the server so a completed order clears
          // the cart everywhere the user signs in.
          clearDraftOrder().catch((err) => {
            console.error('Failed to clear draft order on server:', err)
          })
        } else {
          const keptManufacturers = [
            ...new Set(keptInDraft.map((item) => item?.manufacturer?.name)),
          ]
          ToastPopUp(
            toast,
            'info',
            'Saved to Draft',
            `${keptManufacturers.join(', ')} ${
              keptManufacturers.length === 1 ? 'was' : 'were'
            } kept in your draft order until the minimum order amount is met.`
          )
        }
        // Reset the order data and totals
        setData([])
        setOrderTypeSelections({})
        setShowConfirmContent(false)
        setTermsAccepted(false)
      })
      .catch((e) => {
        setLoading(false)
        setVisible(false)
        
        // Enhanced error handling with specific messages
        let errorTitle = 'Order Failed'
        let errorMessage = 'Your order could not be processed'
        
        if (e.response && e.response.data) {
          const errorData = e.response.data
          
          // Handle specific backend errors
          if (errorData.message) {
            if (errorData.message.includes('not available for ordering')) {
              errorTitle = 'Product Not Available'
              errorMessage = 'One or more products are not available for ordering. Please remove them and try again.'
            } else if (errorData.message.includes('not ordable')) {
              errorTitle = 'Product Not Orderable'
              errorMessage = 'Some products cannot be ordered from their manufacturers. Please check your order and try again.'
            } else if (errorData.message.includes('minimum order')) {
              errorTitle = 'Minimum Order Not Met'
              errorMessage = 'Your order does not meet the minimum order requirements for some manufacturers.'
            } else if (errorData.message.includes('payment')) {
              errorTitle = 'Payment Error'
              errorMessage = 'There was an issue processing your payment. Please check your payment details.'
            } else if (errorData.message.includes('authentication') || errorData.message.includes('unauthorized')) {
              errorTitle = 'Authentication Error'
              errorMessage = 'Your session has expired. Please log in again.'
            } else if (errorData.message.includes('network') || errorData.message.includes('timeout')) {
              errorTitle = 'Connection Error'
              errorMessage = 'Unable to connect to the server. Please check your internet connection and try again.'
            } else {
              // Use the backend message if it's user-friendly
              errorMessage = errorData.message
            }
          }
          
          // Handle HTTP status codes
          if (e.response.status === 400) {
            errorTitle = 'Invalid Order'
            errorMessage = errorMessage || 'Please check your order details and try again.'
          } else if (e.response.status === 401) {
            errorTitle = 'Authentication Required'
            errorMessage = 'Please log in again to continue.'
          } else if (e.response.status === 403) {
            errorTitle = 'Access Denied'
            errorMessage = 'You do not have permission to place this order.'
          } else if (e.response.status === 404) {
            errorTitle = 'Service Unavailable'
            errorMessage = 'The ordering service is temporarily unavailable.'
          } else if (e.response.status >= 500) {
            errorTitle = 'Server Error'
            errorMessage = 'There was a server error. Please try again later.'
          }
        } else if (e.request) {
          // Network error
          errorTitle = 'Connection Error'
          errorMessage = 'Unable to connect to the server. Please check your internet connection.'
        } else {
          // Other errors
          errorTitle = 'Unexpected Error'
          errorMessage = 'An unexpected error occurred. Please try again.'
        }
        
        ToastPopUp(
          toast,
          'error',
          errorTitle,
          errorMessage
        )
      })
  }

  // Calculate PA amount
  const calculatePaAmount = () => {
    if (!paPercentage) return 0

    // Extract numeric total from formatted string
    let numericTotal = total
    if (typeof total === 'string') {
      numericTotal = parseFloat(total.replace(/[^0-9.-]+/g, ''))
    }

    return (paPercentage / 100) * numericTotal
  }

  // Handler to set order type for a manufacturer
  const handleOrderTypeSelect = (manufacturer, type) => {
    setOrderTypeSelections((prev) => ({
      ...prev,
      [manufacturer]: type,
    }))
  }

  const systemLogoBodyTemplate = (rowData) => {
    if (rowData.system === 'Origins Direct') {
      return (
        <img src={originsDirect} alt='Origins Direct' style={{ height: 24 }} />
      )
    } else if (rowData.system === 'Origins Direct Instant') {
      return (
        <img
          src={originsDirectInstant}
          alt='Origins Direct Instant'
          style={{ height: 24 }}
        />
      )
    } else if (rowData.system === 'Origins Management') {
      return (
        <img
          src={originsManagement}
          alt='Origins Management'
          style={{ height: 24 }}
        />
      )
    } else {
      return <span>{rowData.system}</span>
    }
  }

  // Recalculate selected order types when orderData changes
  // Default all orders to "Origins Direct" (systems selection UI is commented out)
  useEffect(() => {
    if (orderData && orderData.length > 0) {
      // Get unique manufacturers from current orderData
      const currentManufacturers = [
        ...new Set(orderData.map((item) => item?.manufacturer?.name)),
      ]

      // Default every manufacturer to "Origins Direct"
      const updatedOrderTypeSelections = {}
      currentManufacturers.forEach((manufacturer) => {
        updatedOrderTypeSelections[manufacturer] = 'Origins Direct'
      })

      setOrderTypeSelections(updatedOrderTypeSelections)
    } else {
      // If no orderData, clear all selections
      setOrderTypeSelections({})
    }
  }, [orderData])

  const modalContent = showConfirmContent ? (
    <ConfirmOrderModal
      orderData={orderData}
      module={module}
      handleSuccess={handleSuccess}
      ordableProducts={ordableProducts}
      pyNumber={pyNumber}
      onClose={() => setVisible(false)}
      onBack={() => setShowConfirmContent(false)}
      onTermsAccepted={setTermsAccepted}
      selectedOrderTypes={orderTypeSelections}
    />
  ) : (
    <>
      <DataTable
        value={manufacturersData}
        paginatorTemplate='FirstPageLink PrevPageLink PageLinks NextPageLink LastPageLink CurrentPageReport RowsPerPageDropdown'
        rowsPerPageOptions={rowsPerPageOptions}
        paginator
        showGridlines
        loading={tableLoading}
        dataKey={manufacturersData.Manufacturer}
        removableSort
        emptyMessage='No orders to display'
        rows={state.rows}
        first={state.first}
        onPage={(e) => setState((prev) => applyPageEvent(prev, e))}
        onSort={(e) => {
          e.first = 0
          setState(e)
        }}
        onFilter={(e) => setState(e)}
      >
        <Column
          field='Manufacturer'
          header='Manufacturer'
          style={{ fontWeight: 'bold' }}
        />
        <Column
          field='TotalAmount'
          header='Total Amount'
          body={(rowData) => formatCurrency(rowData.TotalAmount)}
        />
        <Column
          field='gpMinOrderPrice'
          header='Minimum Order'
          body={(rowData) => formatCurrency(rowData.gpMinOrderPrice)}
        />
        <Column
          // field='gpMinOrderPrice'
          header='Meets Min Order'
          body={(rowData) =>
            rowData.gpMinOrderPrice > rowData.TotalAmount ? (
              <div
                style={{
                  display: 'flex',
                  justifyContent: 'center',
                  alignItems: 'center',
                }}
              >
                <p
                  style={{
                    border: '1px solid #fee2e2',
                    borderRadius: '20px',
                    width: '80%',
                    display: 'flex',
                    justifyContent: 'center',
                    backgroundColor: '#fee2e2',
                    color: '#991b1b',
                    margin: '0px',
                  }}
                >
                  No
                </p>
              </div>
            ) : (
              <div
                style={{
                  display: 'flex',
                  justifyContent: 'center',
                  alignItems: 'center',
                }}
              >
                <p
                  style={{
                    border: '1px solid #dcfce7',
                    borderRadius: '20px',
                    width: '80%',
                    display: 'flex',
                    justifyContent: 'center',
                    backgroundColor: '#dcfce7',
                    color: '#166534',
                    margin: '0px',
                  }}
                >
                  Yes
                </p>
              </div>
            )
          }
        />
        <Column field='deliveryTime' header='Expected Delivery Time' />
        {/* Systems selection column - commented out; all orders default to "Origins Direct". Uncomment to restore. */}
        {/* <Column
          header='Select Order Type'
          body={(rowData) => {
            // Define only Origins Direct and Origins Direct Instant systems
            const allSystems = ['Origins Direct', 'Origins Direct Instant']
            
            // Get user's accessible systems from userData
            // Check if user has access to each system by looking at pharmacyModules
            const hasDirectAccess = userData?.pharmacyModules?.some(
              (module) => module.name === 'Origins Direct'
            )
            const hasDirectInstantAccess = userData?.pharmacyModules?.some(
              (module) => module.name === 'Origins Direct Instant'
            )
            console.log('hasDirectAccess:', hasDirectAccess)
            console.log('hasDirectInstantAccess:', hasDirectInstantAccess)
            console.log('rowData.systems:', rowData.systems)
            
            return (
              <div className='d-flex gap-3 align-items-center justify-content-center'>
                {allSystems.map((system) => {
                  let logo, alt
                  if (system === 'Origins Direct') {
                    logo = originsDirect
                    alt = 'Origins Direct'
                  } else if (system === 'Origins Direct Instant') {
                    logo = originsDirectInstant
                    alt = 'Origins Direct Instant'
                  } else {
                    return null
                  }
                  
                  // Check if user has access to this system
                  const hasAccess = system === 'Origins Direct' ? hasDirectAccess : hasDirectInstantAccess
                  // Check if manufacturer supports this system
                  const manufacturerSupports = (rowData.systems || []).includes(system)
                  // Check if this system is selected
                  const isSelected = orderTypeSelections[rowData.Manufacturer] === system
                  
                  // System is disabled if user doesn't have access OR manufacturer doesn't support it
                  const isDisabled = !hasAccess || !manufacturerSupports
                  
                  console.log(`System: ${system}, hasAccess: ${hasAccess}, manufacturerSupports: ${manufacturerSupports}, isDisabled: ${isDisabled}`)
                  
                  return (
                    <img
                      key={system}
                      src={logo}
                      alt={alt}
                      style={{
                        height: 35,
                        padding: '5px 20px',
                        border: isSelected
                          ? '2.5px solid #2684FF'
                          : '2.5px solid transparent',
                        borderRadius: 25,
                        cursor: isDisabled ? 'not-allowed' : 'pointer',
                        background: isSelected ? '#f0f7ff' : 'white',
                        boxShadow: isSelected
                          ? '0 2px 8px 0 rgba(38,132,255,0.10)'
                          : '0 1px 4px 0 rgba(0,0,0,0.04)',
                        transition: 'all 0.2s',
                        opacity: isDisabled ? 0.4 : (isSelected ? 1 : 0.85),
                        filter: isDisabled ? 'grayscale(100%)' : 'none',
                      }}
                      onClick={() => {
                        console.log(`Clicked on ${system} for ${rowData.Manufacturer}, isDisabled: ${isDisabled}`)
                        if (!isDisabled) {
                          handleOrderTypeSelect(rowData.Manufacturer, system)
                        }
                      }}
                      onMouseOver={(e) => {
                        if (!isSelected && !isDisabled) {
                          e.currentTarget.style.boxShadow = '0 2px 8px 0 #b2d4ff'
                        }
                      }}
                      onMouseOut={(e) => {
                        if (!isSelected && !isDisabled) {
                          e.currentTarget.style.boxShadow = '0 1px 4px 0 rgba(0,0,0,0.04)'
                        }
                      }}
                      title={isDisabled ? 
                        (!hasAccess ? `You don't have access to ${system}` : `${system} not available for this manufacturer`) : 
                        `Select ${system}`
                      }
                    />
                  )
                })}
              </div>
            )
          }}
        /> */}
        <Column
          field='shippingFee'
          header='Shipping Fee'
          body={(rowData) =>
            rowData.shippingFee && rowData.shippingFee !== 0
              ? formatCurrency(rowData.shippingFee)
              : '-'
          }
        />
      </DataTable>
      <div className='mt-5 w-100'>
        <div
          className='p-4 rounded'
          style={{
            maxWidth: 420,
            margin: '0 auto',
            backgroundColor: 'var(--p-content-background)',
            border: '1px solid var(--p-content-border-color, #e5e7eb)',
          }}
        >
          <div className='d-flex justify-content-between align-items-center mb-2'>
            <span className='text-muted'>Subtotal</span>
            <span className='fw-semibold'>{subtotal}</span>
          </div>
          {totalShippingFee !== 0 && (
            <div className='d-flex justify-content-between align-items-center mb-2'>
              <span className='text-muted'>Shipping</span>
              <span className='fw-semibold'>{formatCurrency(totalShippingFee)}</span>
            </div>
          )}
          <div className='d-flex justify-content-between align-items-center mb-2 pt-2' style={{ borderTop: '1px solid var(--p-content-border-color, #e5e7eb)' }}>
            <span className='fw-bold'>Total</span>
            <span className='fw-bold'>{formatCurrency(totalAmount)}</span>
          </div>
          {isOriginsDirectGroupMember && (paData?.paAmount != null || calculatePaAmount() > 0) && (
            <div className='d-flex justify-content-between align-items-center mt-3 pt-2' style={{ borderTop: '1px solid var(--p-content-border-color, #e5e7eb)' }}>
              <span className='text-muted'>Estimated PA</span>
              <span className='fw-semibold'>{formatCurrency(paData?.paAmount ?? calculatePaAmount())}</span>
            </div>
          )}
        </div>
      </div>
    </>
  )

  return (
    <>
      <div className='card flex justify-content-center'>
        <Toast ref={toast} />
      </div>
      <Modals
        btnName={showConfirmContent ? 'BACK' : 'EDIT ORDER'}
        secondBtnName={showConfirmContent ? 'CONFIRM ORDER' : 'NEXT'}
        ModalHeader={
          showConfirmContent ? 'Confirm Your Order' : 'Order Summary'
        }
        visible={visible}
        setVisible={setVisible}
        onButtonClick={
          showConfirmContent
            ? () => setShowConfirmContent(false)
            : () => setVisible(false)
        }
        onSecondButtonClick={
          showConfirmContent
            ? handleOrderConfirm
            : () => {
                // Check if at least one Origins Direct or Origins Direct Instant is selected
                const hasDirectOrderSelected = Object.values(
                  orderTypeSelections
                ).some(
                  (system) =>
                    system === 'Origins Direct' ||
                    system === 'Origins Direct Instant'
                )

                if (!hasDirectOrderSelected) {
                  ToastPopUp(
                    toast,
                    'error',
                    'Error',
                    'Please select at least one Origins Direct or Origins Direct Instant order type to proceed'
                  )
                } else if (itemsToOrder.length === 0) {
                  ToastPopUp(
                    toast,
                    'error',
                    'Minimum Order Not Met',
                    'No manufacturer in your order meets its minimum order amount yet.'
                  )
                } else {
                  setShowConfirmContent(true)
                }
              }
        }
        loading={loading}
        wait={true}
        width='60rem'
        secondButtonDisabled={
          showConfirmContent && (!termsAccepted || itemsToOrder.length === 0)
        }
        btnClassName='p-button-outlined'
      >
        {showConfirmContent ? (
          <>
            <OrderSplitSummary manufacturersData={manufacturersData} />
            <ConfirmOrderModal
            orderData={data.map(item => {
              const manufacturerTotal = manufacturerTotals[item?.manufacturer?.name]
              return {
                ...item,
                confirmed: manufacturerTotal ? manufacturerTotal.gpMinOrderPrice <= manufacturerTotal.TotalAmount : true
              }
            })}
            module={module}
            handleSuccess={handleSuccess}
            ordableProducts={ordableProducts}
            pyNumber={pyNumber}
            onClose={() => setVisible(false)}
            onBack={() => setShowConfirmContent(false)}
            onTermsAccepted={setTermsAccepted}
            selectedOrderTypes={orderTypeSelections}
          />
          </>
        ) : (
          modalContent
        )}
      </Modals>
    </>
  )
}

// Lists which manufacturer orders will be placed now and which stay in the draft
// because they are below the manufacturer's minimum order amount.
const OrderSplitSummary = ({ manufacturersData }) => {
  const toPlace = manufacturersData.filter((m) => m.confirmed)
  const toKeep = manufacturersData.filter((m) => !m.confirmed)

  return (
    <div className='mb-3'>
      <div className='fw-bold mb-2'>
        <i className='pi pi-check-circle me-2' style={{ color: '#166534' }}></i>
        Orders to be placed ({toPlace.length})
      </div>
      {toPlace.length > 0 ? (
        <ul className='list-unstyled mb-3 ps-4'>
          {toPlace.map((m) => (
            <li key={m.Manufacturer} className='d-flex justify-content-between'>
              <span>{m.Manufacturer}</span>
              <span className='fw-semibold'>{formatCurrency(m.TotalAmount)}</span>
            </li>
          ))}
        </ul>
      ) : (
        <p className='text-muted ps-4 mb-3'>
          No manufacturer meets its minimum order amount yet.
        </p>
      )}
      {toKeep.length > 0 && (
        <div className='alert alert-info mb-0' role='status'>
          <div className='fw-bold mb-1'>
            <i className='pi pi-bookmark me-2'></i>
            Kept in draft ({toKeep.length}): below minimum order amount
          </div>
          <ul className='list-unstyled mb-1 ps-4'>
            {toKeep.map((m) => (
              <li key={m.Manufacturer} className='d-flex justify-content-between'>
                <span>{m.Manufacturer}</span>
                <span>
                  {formatCurrency(m.TotalAmount)} of{' '}
                  {formatCurrency(m.gpMinOrderPrice)} minimum
                </span>
              </li>
            ))}
          </ul>
          <small>
            These items stay in your order so you can add to them and place
            them later.
          </small>
        </div>
      )}
    </div>
  )
}

export default OrderSummary
